import React from 'react'
import { ChecklistGrid, Block } from '@components'

const DatoCmsChecklistGrid = ({
  paddingTop,
  paddingBottom,
  backgroundColour,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      backgroundColour={backgroundColour}
    >
      <ChecklistGrid {...props} />
    </Block>
  )
}

export default DatoCmsChecklistGrid
